import AddOnService from "../services/AddOnService";
export const FETCH_ADD_ONS_SUCCESS = "FETCH_ADD_ONS_SUCCESS";

export const GET_ADD_ONS_SUCCESS = "GET_ADD_ONS_SUCCESS";
export const GET_ADD_ONS_FAILED = "GET_ADD_ONS_FAILED";

const fetchAddOnsSuccess = (addOns) => ({
  type: FETCH_ADD_ONS_SUCCESS,
  payload: addOns,
});

// fetch brands
export const fetchAddOns = (addOns) => {
  return (dispatch) => {
    dispatch(fetchAddOnsSuccess(addOns));
  };
};
//////////////////

export const getAddOns = () => {
  return (dispatch) => {
    AddOnService.getAll()
      .then((res) => {
        dispatch({
          type: GET_ADD_ONS_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_ADD_ONS_FAILED,
          payload: err,
        });
      });
  };
};
